import request from '@/api/request'

//  主要参加人页面 主要参加人数据保存
export const participantsAdd = (data,params) => {
    return request({
        url: '/participants-user/addBatch',
        method: 'POST',
        data: data,
        params:params
    })
}